export const tempData = [
  {
    id: "627",
    unitName: "S42-01",
    unitType: "33532",
    unitType_OLD: "33532",
    beds: "3",
    aspect: "E",
    floor: null,
    price: null,
    status: "Reserved",
    viewID: null,
    typology: null,
    cameraPositionID: null,
    address_1: null,
    address_2: null,
    address_3: null,
    postcode: null,
    service_charge: null,
    ppr: null,
    lease_length: null,
    area: null,
  },
  {
    id: "628",
    unitName: "S42-02",
    unitType: "33531",
    unitType_OLD: "33531",
    beds: "3",
    aspect: "S",
    floor: null,
    price: null,
    status: "Reserved",
    viewID: null,
    typology: null,
    cameraPositionID: null,
    address_1: null,
    address_2: null,
    address_3: null,
    postcode: null,
    service_charge: null,
    ppr: null,
    lease_length: null,
    area: null,
  },
  {
    id: "629",
    unitName: "S42-03",
    unitType: "33531",
    unitType_OLD: "33531",
    beds: "3",
    aspect: "N/E",
    floor: null,
    price: null,
    status: "Reserved",
    viewID: null,
    typology: null,
    cameraPositionID: null,
    address_1: null,
    address_2: null,
    address_3: null,
    postcode: null,
    service_charge: null,
    ppr: null,
    lease_length: null,
    area: null,
  },
  {
    id: "630",
    unitName: "S42-04",
    unitType: "33531",
    unitType_OLD: "33531",
    beds: "3",
    aspect: "S",
    floor: null,
    price: null,
    status: "Reserved",
    viewID: null,
    typology: null,
    cameraPositionID: null,
    address_1: null,
    address_2: null,
    address_3: null,
    postcode: null,
    service_charge: null,
    ppr: null,
    lease_length: null,
    area: null,
  },
  {
    id: "631",
    unitName: "S42-05",
    unitType: "33531",
    unitType_OLD: "33531",
    beds: "3",
    aspect: "S/W",
    floor: "0",
    price: "694000",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "1.63, 0.53, 0.59",
    address_1: null,
    address_2: "30",
    address_3: "PROSPECT VALE",
    postcode: "SE18 5DX",
    service_charge: "373.65",
    ppr: "694000",
    lease_length: "Freehold",
    area: "1,218",
  },
  {
    id: "632",
    unitName: "S42-06",
    unitType: "33531",
    unitType_OLD: "33531",
    beds: "3",
    aspect: "N",
    floor: "0",
    price: "694000",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "1.63, 0.53, 0.59",
    address_1: null,
    address_2: "32",
    address_3: "PROSPECT VALE",
    postcode: "SE18 5DX",
    service_charge: "373.65",
    ppr: "694000",
    lease_length: "Freehold",
    area: "1,218",
  },
  {
    id: "633",
    unitName: "S42-07",
    unitType: "33531",
    unitType_OLD: "33531",
    beds: "3",
    aspect: "E",
    floor: "0",
    price: "694000",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "1.63, 0.53, 0.59",
    address_1: null,
    address_2: "34",
    address_3: "PROSPECT VALE",
    postcode: "SE18 5DX",
    service_charge: "373.65",
    ppr: "694000",
    lease_length: "Freehold",
    area: "1,218",
  },
  {
    id: "634",
    unitName: "S42-08",
    unitType: "33531",
    unitType_OLD: "33531",
    beds: "3",
    aspect: "S",
    floor: "0",
    price: "694000",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "1.63, 0.53, 0.59",
    address_1: null,
    address_2: "36",
    address_3: "PROSPECT VALE",
    postcode: "SE18 5DX",
    service_charge: "373.65",
    ppr: "694000",
    lease_length: "Freehold",
    area: "1,218",
  },
  {
    id: "635",
    unitName: "S42-09",
    unitType: "33532",
    unitType_OLD: "33532",
    beds: "3",
    aspect: "N/E",
    floor: "0",
    price: "703500",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "1.63, 0.53, 0.59",
    address_1: null,
    address_2: "38",
    address_3: "PROSPECT VALE",
    postcode: "SE18 5DX",
    service_charge: "377.64",
    ppr: "703500",
    lease_length: "Freehold",
    area: "1,231",
  },
  {
    id: "636",
    unitName: "S43-01",
    unitType: "43619",
    unitType_OLD: "43619",
    beds: "3",
    aspect: "S",
    floor: "0",
    price: "746000",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.76, 0.53, 0.73",
    address_1: null,
    address_2: "11",
    address_3: "ARTHUR DRUMMOND AVE",
    postcode: "SE18 5DW",
    service_charge: "420.89",
    ppr: "746000",
    lease_length: "Freehold",
    area: "1,372",
  },
  {
    id: "637",
    unitName: "S43-02",
    unitType: "43605",
    unitType_OLD: "43605",
    beds: "3",
    aspect: "S/W",
    floor: "0",
    price: "717500",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.76, 0.53, 0.73",
    address_1: null,
    address_2: "9",
    address_3: "ARTHUR DRUMMOND AVE",
    postcode: "SE18 5DW",
    service_charge: "395.43",
    ppr: "717500",
    lease_length: "Freehold",
    area: "1,289",
  },
  {
    id: "638",
    unitName: "S43-03",
    unitType: "43622",
    unitType_OLD: "43622",
    beds: "3",
    aspect: "N",
    floor: "0",
    price: "746000",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.76, 0.53, 0.73",
    address_1: null,
    address_2: "7",
    address_3: "ARTHUR DRUMMOND AVE",
    postcode: "SE18 5DW",
    service_charge: "420.89",
    ppr: "746000",
    lease_length: "Freehold",
    area: "1,372",
  },
  {
    id: "641",
    unitName: "S46-01",
    unitType: "23402",
    unitType_OLD: "23402",
    beds: "3",
    aspect: "E",
    floor: "0",
    price: "576000",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "1.38, 0.52, -0.84",
    address_1: "FLAT G01",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "2533.81",
    ppr: "576000",
    lease_length: "999 Years",
    area: "935",
  },
  {
    id: "642",
    unitName: "S46-02",
    unitType: "23513",
    unitType_OLD: "23513",
    beds: "3",
    aspect: "S",
    floor: "0",
    price: "614000",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "1.01, 0.54, 0.13",
    address_1: "FLAT G02",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "2536.52",
    ppr: "614000",
    lease_length: "999 Years",
    area: "1,014",
  },
  {
    id: "643",
    unitName: "S46-03",
    unitType: "23401",
    unitType_OLD: "23401",
    beds: "3",
    aspect: "N/E",
    floor: "0",
    price: "576000",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "1.52, 0.47, 0.02",
    address_1: "FLAT G03",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "2747.89",
    ppr: "576000",
    lease_length: "999 Years",
    area: "936",
  },
  {
    id: "644",
    unitName: "S46-04",
    unitType: "23514",
    unitType_OLD: "23514",
    beds: "3",
    aspect: "S",
    floor: "1",
    price: "569500",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "1.38, 0.52, -0.84",
    address_1: "FLAT 101",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "2669.31",
    ppr: "569500",
    lease_length: "999 Years",
    area: "936",
  },
  {
    id: "645",
    unitName: "S46-05",
    unitType: "21213",
    unitType_OLD: "21213",
    beds: "1",
    aspect: "S/W",
    floor: "1",
    price: "370000",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "1.24, 0.46, -0.95",
    address_1: "FLAT 102",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "1498.60",
    ppr: "370000",
    lease_length: "999 Years",
    area: "553",
  },
  {
    id: "646",
    unitName: "S46-06",
    unitType: "23512",
    unitType_OLD: "23512",
    beds: "3",
    aspect: "N",
    floor: "1",
    price: "593000",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "0.54, 0.5, -0.18",
    address_1: "FLAT 103",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "2536.52",
    ppr: "593000",
    lease_length: "999 Years",
    area: "985",
  },
  {
    id: "647",
    unitName: "S46-07",
    unitType: "23513",
    unitType_OLD: "23513",
    beds: "3",
    aspect: "E",
    floor: "1",
    price: "602500",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "1.01, 0.54, 0.13",
    address_1: "FLAT 104",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "2536.52",
    ppr: "602500",
    lease_length: "999 Years",
    area: "1,014",
  },
  {
    id: "648",
    unitName: "S46-08",
    unitType: "23515",
    unitType_OLD: "23515",
    beds: "3",
    aspect: "S",
    floor: "1",
    price: "564500",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "1.52, 0.47, 0.02",
    address_1: "FLAT 105",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "2747.89",
    ppr: "564500",
    lease_length: "999 Years",
    area: "936",
  },
  {
    id: "649",
    unitName: "S46-09",
    unitType: "23514",
    unitType_OLD: "23514",
    beds: "3",
    aspect: "N/E",
    floor: "2",
    price: "572000",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "1.38, 0.52, -0.84",
    address_1: "FLAT 201",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "2669.31",
    ppr: "572000",
    lease_length: "999 Years",
    area: "936",
  },
  {
    id: "650",
    unitName: "S46-10",
    unitType: "21213",
    unitType_OLD: "21213",
    beds: "1",
    aspect: "S",
    floor: "2",
    price: "371000",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "1.22, 0.46, -0.95",
    address_1: "FLAT 202",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "1498.60",
    ppr: "371000",
    lease_length: "999 Years",
    area: "553",
  },
  {
    id: "651",
    unitName: "S46-11",
    unitType: "23512",
    unitType_OLD: "23512",
    beds: "3",
    aspect: "S/W",
    floor: "2",
    price: "596000",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "0.54, 0.5, -0.18",
    address_1: "FLAT 203",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "2536.52",
    ppr: "596000",
    lease_length: "999 Years",
    area: "985",
  },
  {
    id: "652",
    unitName: "S46-12",
    unitType: "23513",
    unitType_OLD: "23513",
    beds: "3",
    aspect: "N",
    floor: "2",
    price: "605500",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "1.06, 0.54, 0.12",
    address_1: "FLAT 204",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "2536.52",
    ppr: "605500",
    lease_length: "999 Years",
    area: "1,014",
  },
  {
    id: "653",
    unitName: "S46-13",
    unitType: "23515",
    unitType_OLD: "23515",
    beds: "3",
    aspect: "E",
    floor: "2",
    price: "567500",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "1.52, 0.47, 0.02",
    address_1: "FLAT 205",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "2747.89",
    ppr: "567500",
    lease_length: "999 Years",
    area: "936",
  },
  {
    id: "654",
    unitName: "S46-14",
    unitType: "23514",
    unitType_OLD: "23514",
    beds: "3",
    aspect: "S",
    floor: "3",
    price: "574000",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "1.38, 0.52, -0.84",
    address_1: "FLAT 301",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "2669.31",
    ppr: "574000",
    lease_length: "999 Years",
    area: "936",
  },
  {
    id: "655",
    unitName: "S46-15",
    unitType: "21213",
    unitType_OLD: "21213",
    beds: "1",
    aspect: "N/E",
    floor: "3",
    price: "372500",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "1.22, 0.46, -0.95",
    address_1: "FLAT 302",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "1498.60",
    ppr: "372500",
    lease_length: "999 Years",
    area: "553",
  },
  {
    id: "656",
    unitName: "S46-16",
    unitType: "23512",
    unitType_OLD: "23512",
    beds: "3",
    aspect: "S",
    floor: "3",
    price: "598000",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "0.54, 0.5, -0.18",
    address_1: "FLAT 303",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "2536.52",
    ppr: "598000",
    lease_length: "999 Years",
    area: "985",
  },
  {
    id: "657",
    unitName: "S46-17",
    unitType: "23513",
    unitType_OLD: "23513",
    beds: "3",
    aspect: "S/W",
    floor: "3",
    price: "607500",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "1.06, 0.54, 0.12",
    address_1: "FLAT 304",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "2536.52",
    ppr: "607500",
    lease_length: "999 Years",
    area: "1,014",
  },
  {
    id: "658",
    unitName: "S46-18",
    unitType: "23515",
    unitType_OLD: "23515",
    beds: "3",
    aspect: "S",
    floor: "3",
    price: "569500",
    status: "Available",
    viewID: "N/A",
    typology: "Apartment",
    cameraPositionID: "1.52, 0.47, 0.02",
    address_1: "FLAT 305",
    address_2: "HENRY CHANCE HOUSE",
    address_3: "76 BANNERMAN STREET",
    postcode: "SE18 5EQ",
    service_charge: "2747.89",
    ppr: "569500",
    lease_length: "999 Years",
    area: "936",
  },
  {
    id: "659",
    unitName: "S51-01",
    unitType: "43603",
    unitType_OLD: "43603",
    beds: "3",
    aspect: "S/W",
    floor: "0",
    price: "746000",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.28, 0.63, -0.08",
    address_1: null,
    address_2: "58",
    address_3: "BANNERMAN STREET",
    postcode: "SE18 5BW",
    service_charge: "399.73",
    ppr: "746000",
    lease_length: "Freehold",
    area: "1,303",
  },
  {
    id: "660",
    unitName: "S51-02",
    unitType: "43605",
    unitType_OLD: "43605",
    beds: "3",
    aspect: "N",
    floor: "0",
    price: "736500",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.28, 0.63, -0.08",
    address_1: null,
    address_2: "60",
    address_3: "BANNERMAN STREET",
    postcode: "SE18 5BW",
    service_charge: "395.43",
    ppr: "736500",
    lease_length: "Freehold",
    area: "1,289",
  },
  {
    id: "661",
    unitName: "S51-03",
    unitType: "43601",
    unitType_OLD: "43601",
    beds: "3",
    aspect: "c",
    floor: "0",
    price: "736500",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.28, 0.63, -0.08",
    address_1: null,
    address_2: "62",
    address_3: "BANNERMAN STREET",
    postcode: "SE18 5BW",
    service_charge: "395.43",
    ppr: "736500",
    lease_length: "Freehold",
    area: "1,289",
  },
  {
    id: "662",
    unitName: "S51-04",
    unitType: "43605",
    unitType_OLD: "43605",
    beds: "3",
    aspect: "S",
    floor: "0",
    price: "736500",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.28, 0.63, -0.08",
    address_1: null,
    address_2: "64",
    address_3: "BANNERMAN STREET",
    postcode: "SE18 5BW",
    service_charge: "395.43",
    ppr: "736500",
    lease_length: "Freehold",
    area: "1,289",
  },
  {
    id: "663",
    unitName: "S51-05",
    unitType: "43601",
    unitType_OLD: "43601",
    beds: "3",
    aspect: "N/E",
    floor: "0",
    price: "736500",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.33, 0.67, -0.15",
    address_1: null,
    address_2: "66",
    address_3: "BANNERMAN STREET",
    postcode: "SE18 5BW",
    service_charge: "395.43",
    ppr: "736500",
    lease_length: "Freehold",
    area: "1,289",
  },
  {
    id: "664",
    unitName: "S51-06",
    unitType: "43605",
    unitType_OLD: "43605",
    beds: "3",
    aspect: "S",
    floor: "0",
    price: "736500",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.33, 0.67, -0.15",
    address_1: null,
    address_2: "68",
    address_3: "BANNERMAN STREET",
    postcode: "SE18 5BW",
    service_charge: "395.43",
    ppr: "736500",
    lease_length: "Freehold",
    area: "1,289",
  },
  {
    id: "665",
    unitName: "S51-07",
    unitType: "43601",
    unitType_OLD: "43601",
    beds: "3",
    aspect: "S/W",
    floor: "0",
    price: "736500",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.33, 0.67, -0.15",
    address_1: null,
    address_2: "70",
    address_3: "BANNERMAN STREET",
    postcode: "SE18 5BW",
    service_charge: "395.43",
    ppr: "736500",
    lease_length: "Freehold",
    area: "1,289",
  },
  {
    id: "666",
    unitName: "S51-08",
    unitType: "43605",
    unitType_OLD: "43605",
    beds: "3",
    aspect: "N",
    floor: "0",
    price: "736500",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.33, 0.67, -0.15",
    address_1: null,
    address_2: "72",
    address_3: "BANNERMAN STREET",
    postcode: "SE18 5BW",
    service_charge: "395.43",
    ppr: "736500",
    lease_length: "Freehold",
    area: "1,289",
  },
  {
    id: "667",
    unitName: "S51-09",
    unitType: "43603",
    unitType_OLD: "43603",
    beds: "3",
    aspect: "E",
    floor: "0",
    price: "746000",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.33, 0.67, -0.15",
    address_1: null,
    address_2: "74",
    address_3: "BANNERMAN STREET",
    postcode: "SE18 5BW",
    service_charge: "399.73",
    ppr: "746000",
    lease_length: "Freehold",
    area: "1,303",
  },
  {
    id: "670",
    unitName: "S53-01",
    unitType: "43615",
    unitType_OLD: "43615",
    beds: "3",
    aspect: "E",
    floor: "0",
    price: "722500",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.87, 0.57, 0.43",
    address_1: null,
    address_2: "9",
    address_3: "STEWER STREET",
    postcode: "SE18 5DY",
    service_charge: "369.35",
    ppr: "722500",
    lease_length: "Freehold",
    area: "1,204",
  },
  {
    id: "671",
    unitName: "S53-02",
    unitType: "43615",
    unitType_OLD: "43615",
    beds: "3",
    aspect: "W",
    floor: "0",
    price: "722500",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.87, 0.57, 0.43",
    address_1: null,
    address_2: "11",
    address_3: "STEWER STREET",
    postcode: "SE18 5DY",
    service_charge: "369.35",
    ppr: "722500",
    lease_length: "Freehold",
    area: "1,204",
  },
  {
    id: "672",
    unitName: "S54-01",
    unitType: "43611",
    unitType_OLD: "43611",
    beds: "3",
    aspect: "N",
    floor: "0",
    price: "722500",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.91, 0.57, 0.3",
    address_1: null,
    address_2: "13",
    address_3: "STEWER STREET",
    postcode: "SE18 5DY",
    service_charge: "370.58",
    ppr: "722500",
    lease_length: "Freehold",
    area: "1,208",
  },
  {
    id: "639",
    unitName: "S44-01",
    unitType: "43612",
    unitType_OLD: "43612",
    beds: "3",
    aspect: "S",
    floor: "0",
    price: "732000",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.75, 0.52, 0.21",
    address_1: null,
    address_2: "10",
    address_3: "STEWER STREET",
    postcode: "SE18 5DY",
    service_charge: "370.58",
    ppr: "732000",
    lease_length: "Freehold",
    area: "1,208",
  },
  {
    id: "640",
    unitName: "S45-01",
    unitType: "43612",
    unitType_OLD: "43612",
    beds: "3",
    aspect: "S/W",
    floor: "0",
    price: "727000",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.75, 0.51, 0.24",
    address_1: null,
    address_2: "12",
    address_3: "STEWER STREET",
    postcode: "SE18 5DY",
    service_charge: "370.58",
    ppr: "727000",
    lease_length: "Freehold",
    area: "1,191",
  },
  {
    id: "668",
    unitName: "S52-01",
    unitType: "43603",
    unitType_OLD: "43603",
    beds: "3",
    aspect: "N",
    floor: "0",
    price: "732000",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.61, 0.55, 0.6",
    address_1: null,
    address_2: "5",
    address_3: "ARTHUR DRUMMOND AVE",
    postcode: "SE18 5DW",
    service_charge: "398.80",
    ppr: "732000",
    lease_length: "Freehold",
    area: "1,300",
  },
  {
    id: "669",
    unitName: "S52-02",
    unitType: "43606",
    unitType_OLD: "43606",
    beds: "3",
    aspect: "E",
    floor: "0",
    price: "732000",
    status: "Available",
    viewID: "N/A",
    typology: "House",
    cameraPositionID: "0.61, 0.55, 0.6",
    address_1: null,
    address_2: "3",
    address_3: "ARTHUR DRUMMOND AVE",
    postcode: "SE18 5DW",
    service_charge: "398.80",
    ppr: "732000",
    lease_length: "Freehold",
    area: "1,300",
  },
]
